module.exports = __webpack_public_path__ + "static/media/key_bg.9a04656c.png";